
import {createApp} from "vue";
import RetailersMap from "./vueComponents/RetailersMap.vue";

export default {
    name      : 'map',
    init() {
        const containers = document.querySelectorAll('.js-map');

        if (!containers.length) {
            return;
        }

        containers.forEach(container => {
            const app = createApp({
                delimiters: ['${', '}'],
            });

            app.component('retailers-map', RetailersMap);
            app.mount(container)
        });
    }
}

